import { FormDataModel } from '@/model/FormModel'

export const FromFieldData: FormDataModel[] = [
  {
    title: '基本信息',
    type: 1, // 常规表单
    labelClass: 'blue',
    labelName: '基',
    formList: [
      {
        componentType: 'el-select',
        componentName: '下拉选择',
        fieldKey: 'superId',
        fieldName: '上级人员',
        placeholder: '',
        value: 0,
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        option: [{
          id: 0,
          name: '顶级'
        }],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'user/dropdowns/availableSuperUser',
          params: {
            id: 'excludeUserId'
          },
          pickerType: '',
          filterable: true,
          selectType: 2, // 1本地2远程
          label: 'mark',
          fromPage: 'user'
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'name',
        fieldName: '姓名',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'username',
        fieldName: '用户名',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          autocomplete: 'new-password',
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-select',
        componentName: '下拉选择',
        fieldKey: 'sex',
        fieldName: '性别',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'Sex',
          pickerType: '',
          filterable: true,
          selectType: 1// 1本地2远程
        }
      }, {
        componentType: 'el-select',
        componentName: '下拉选择',
        fieldKey: 'dataAuthority',
        fieldName: '数据权限',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: false,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'DataAuthority',
          pickerType: '',
          filterable: true,
          selectType: 1// 1本地2远程
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'idCard',
        fieldName: '身份证',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'email',
        fieldName: '邮箱',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'phone',
        fieldName: '手机号',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-select',
        componentName: '下拉选择',
        fieldKey: 'roleIds',
        fieldName: '设置角色',
        placeholder: '',
        value: [],
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: true,
          clearable: true,
          url: 'role/page',
          pickerType: '',
          filterable: true,
          selectType: 2// 1本地2远程
        }
      }, {
        componentType: 'el-cascader',
        componentName: '下拉选择',
        fieldKey: 'deptIds',
        fieldName: '所属部门',
        placeholder: '',
        value: [],
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          props: {
            label: 'name', children: 'children', value: 'id', checkStrictly: true
          },
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'dept/tree',
          filterable: true,
          selectType: 2
        }
      }, {
        componentType: 'el-date-picker',
        componentName: '日期选择',
        fieldKey: 'birthday',
        fieldName: '生日',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '', trigger: 'change' }],
        option: [],
        config: {
          isDisabled: false,
          clearable: true,
          type: 'date',
          format: 'YYYY-MM-DD',
          valueFormat: 'YYYY-MM-DD'
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'basicPay',
        fieldName: '基本工资',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-select',
        componentName: '下拉选择',
        fieldKey: 'levelId',
        fieldName: '业务提成比例',
        placeholder: '',
        value: [],
        rules: [{ required: false, message: '', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'commission/page',
          pickerType: '',
          filterable: true,
          selectType: 2// 1本地2远程
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'nation',
        fieldName: '民族',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-select',
        componentName: '下拉选择',
        fieldKey: 'marital',
        fieldName: '婚姻状况',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'Marriage',
          pickerType: '',
          filterable: true,
          selectType: 1// 1本地2远程
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'nativePlace',
        fieldName: '籍贯',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-cascader-provinces',
        componentName: '省市区级联',
        fieldKey: 'registerPlace',
        fieldName: '户籍地',
        placeholder: '',
        value: [],
        rules: [{ required: false, message: '', trigger: 'change' }],
        option: [],
        config: {
          isDisabled: false,
          multiple: true,
          clearable: true,
          filterable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'registerPlaceDetail',
        fieldName: '户籍详细地址',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-cascader-provinces',
        componentName: '省市区级联',
        fieldKey: 'livePlace',
        fieldName: '居住地',
        placeholder: '',
        value: [],
        rules: [{ required: false, message: '', trigger: 'change' }],
        option: [],
        config: {
          isDisabled: false,
          multiple: true,
          clearable: true,
          filterable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'livePlaceDetail',
        fieldName: '居住地详细地址',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'homePhone',
        fieldName: '家庭电话',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-select',
        componentName: '下拉选择',
        fieldKey: 'highestEducation',
        fieldName: '最高学历',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'Education',
          pickerType: '',
          filterable: true,
          selectType: 1// 1本地2远程
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'graduated',
        fieldName: '毕业院校',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-date-picker',
        componentName: '日期选择',
        fieldKey: 'entryDate',
        fieldName: '入职时间',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '', trigger: 'change' }],
        option: [],
        config: {
          isDisabled: false,
          clearable: true,
          type: 'date',
          format: 'YYYY-MM-DD',
          valueFormat: 'YYYY-MM-DD'
        }
      }, {
        componentType: 'el-date-picker',
        componentName: '日期选择',
        fieldKey: 'leaveDate',
        fieldName: '离职时间',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '', trigger: 'change' }],
        option: [],
        config: {
          isDisabled: false,
          clearable: true,
          type: 'date',
          format: 'YYYY-MM-DD',
          valueFormat: 'YYYY-MM-DD'
        }
      }, {
        componentType: 'el-upload',
        componentName: '上传头像',
        fieldKey: 'image',
        fieldName: '头像',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '', trigger: 'change' }],
        option: [],
        config: {
          isAvatar: true,
          width: '100%',
          limit: 1,
          isDisabled: false,
          clearable: true,
          url: 'https://jsonplaceholder.typicode.com/posts/'
        }
      }
    ]
  }, {
    title: '工资卡',
    type: 2,
    labelClass: 'yellow',
    labelName: '工',
    formList: [
      {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'payList',
        fieldName: '渲染列表',
        config: {},
        id: 0,
        list: [
          {
            componentType: 'el-select',
            componentName: '下拉选择',
            fieldKey: 'type',
            fieldName: '类型',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            option: [],
            config: {
              collapseTags: true,
              isDisabled: false,
              multiple: false,
              clearable: true,
              url: 'UserPayType',
              pickerType: '',
              filterable: true,
              selectType: 1// 1本地2远程
            }
          }, {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'name',
            fieldName: '开户名/收款人姓名',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false
            }
          }, {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'branchName',
            fieldName: '开户网点/账户昵称',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false
            }
          }, {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'account',
            fieldName: '账号',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false
            }
          }
        ]
      }
    ]
  }
]
